import { render, staticRenderFns } from "./OpeningBalancePGEdit.vue?vue&type=template&id=a9e2c920&"
import script from "./OpeningBalancePGEdit.vue?vue&type=script&lang=js&"
export * from "./OpeningBalancePGEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports